import React from 'react';
import './ui.css';

/**
 * Labelled control wrapper used by the filter bar and every form.
 * Label is 10.5px/600/.06em uppercase; the error message sits below at 11.5px crimson.
 */
export function Field({ label, htmlFor, error, hint, required, children, className = '' }) {
  return (
    <div className={`sv-field ${className}`}>
      {label && (
        <label className="sv-field__label" htmlFor={htmlFor}>
          {label}
          {required && <span className="sv-field__required"> *</span>}
        </label>
      )}
      {children}
      {hint && !error && <div className="sv-field__hint">{hint}</div>}
      {error && <div className="sv-field__error">{error}</div>}
    </div>
  );
}

export const TextInput = React.forwardRef(function TextInput(
  { icon, invalid = false, className = '', ...rest },
  ref
) {
  return (
    <div className={`sv-input-wrap ${icon ? 'has-icon' : ''} ${invalid ? 'is-invalid' : ''} ${className}`}>
      {icon && <i className={`bx ${icon} sv-input-wrap__icon`} aria-hidden="true" />}
      <input ref={ref} className="sv-input" {...rest} />
    </div>
  );
});

export const Select = React.forwardRef(function Select(
  { options = [], placeholder, invalid = false, className = '', ...rest },
  ref
) {
  return (
    <div className={`sv-select-wrap ${invalid ? 'is-invalid' : ''} ${className}`}>
      <select ref={ref} className="sv-select" {...rest}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => {
          const value = typeof opt === 'string' ? opt : opt.value;
          const label = typeof opt === 'string' ? opt : opt.label;
          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </select>
      <i className="bx bx-chevron-down sv-select-wrap__chevron" aria-hidden="true" />
    </div>
  );
});

export const Textarea = React.forwardRef(function Textarea(
  { invalid = false, className = '', ...rest },
  ref
) {
  return <textarea ref={ref} className={`sv-textarea ${invalid ? 'is-invalid' : ''} ${className}`} {...rest} />;
});

export default Field;
